import Marionette from "backbone.marionette";
import { sanitizeString } from "../../../../utils";
import templates from "../../../../utils/templates";
import environment from "../../../../common/environment";

const NAME_REGEX = "[^A-Za-z0-9-_ &+]+";
const NAME_TAKEN =
  "This project name is already in use. Please enter a different one.";
const NAME_AVAILABLE = "This project name is available!";
const ICON_PENCIL = "fa-pencil";
const ICON_SUCCESS = "fa-check";
const ICON_WARN = "fa-exclamation-triangle";

const DEFAULTS = {
  template: templates.find("chart_reviews", "project_edit"),
};

class View extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  initialize() {
    this.validateNameUrl = environment.getEndpoint(
      "chart-reviews:projects:validate-name"
    );
  }

  ui() {
    return {
      name: "input#name",
    };
  }

  events() {
    return {
      "keyup @ui.name": _.debounce(this._onNameChange, 1000),
    };
  }

  _onNameChange(e) {
    const $el = $(e.target);
    const $parent = $el.parents(".form-group");
    const $icon = $(".input-group-addon > i", $parent);
    const $help = $(".help-block", $parent);

    // get name and sanitize it
    const name = sanitizeString($el.val(), NAME_REGEX);

    // set input value to clean name
    $el.val(name);

    // clear previous validation classes and message
    $parent.removeClass("has-error has-warning has-success");
    $icon.removeClass(`${ICON_WARN} ${ICON_SUCCESS}`).addClass(ICON_PENCIL);
    $help.text("");

    // // validate project name when it is not empty and it has changed
    if (name !== "" && name !== this.model.getName()) {
      // validate project name
      $.ajax({
        url: `${this.validateNameUrl}/${name}`,
        statusCode: {
          409() {
            // HTTP 409 indicates the project name is already in use.
            $parent.addClass("has-error");
            $icon.removeClass(ICON_PENCIL).addClass(ICON_WARN);
            $help.text(NAME_TAKEN);
            $el.focus();
          },
          204() {
            // HTTP 204 indicates the project name is NOT in use.
            $parent.addClass("has-success");
            $icon.removeClass(ICON_PENCIL).addClass(ICON_SUCCESS);
            $help.text(NAME_AVAILABLE);
          },
        },
      });
    }
  }
}

export { View as default };
